/* Fardo.cl — Orden inteligente de colecciones.
   Vista por defecto (sin filtros ni orden elegido): primero productos CON STOCK ordenados por
   precio de oferta de mayor a menor; al final los "Proximamente disponible" (sin stock), tambien
   de mayor a menor. Usa los filtros nativos de Shopify (disponibilidad + sort_by) via Section
   Rendering, por lo que se mantiene correcto solo cuando cambia el stock o los precios.
   Si algo falla, se muestra la grilla original. */
(function () {
  var root = document.documentElement;
  function reveal() { root.classList.remove('fv-smart'); }

  function run() {
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.id || grid.tagName !== 'UL') { reveal(); return; }
    var params = new URLSearchParams(location.search);
    if ((params.get('page') && params.get('page') !== '1') || params.get('sort_by') || params.get('q')) { reveal(); return; }
    for (var k of params.keys()) { if (k.indexOf('filter.') === 0) { reveal(); return; } }

    var sid = grid.dataset.id;
    var pag = document.querySelector('pagination-theme[data-section="' + sid + '"]');
    if (pag) {
      if (pag.observer) pag.observer.disconnect();
      pag.style.display = 'none';
    }

    var phases = [{ a: 1, page: 1 }, { a: 0, page: 1 }];
    var ph = 0, busy = false, finished = false, seen = {};
    var sentinel = document.createElement('div');
    sentinel.className = 'fv-sort-sentinel';
    sentinel.style.cssText = 'height:1px;width:100%;';
    grid.parentNode.insertBefore(sentinel, grid.nextSibling);

    function key(li) {
      var a = li.querySelector('a[href*="/products/"]');
      if (!a) return null;
      try { return new URL(a.getAttribute('href'), location.origin).pathname.split('/products/')[1]; } catch (e) { return null; }
    }
    function url(p) {
      return location.pathname + '?section_id=' + encodeURIComponent(sid) +
        '&filter.v.availability=' + p.a + '&sort_by=price-descending&page=' + p.page;
    }
    function unveil(el) {
      if (window.lazySizes) el.querySelectorAll('.lazyload').forEach(function (i) { lazySizes.loader.unveil(i); });
    }
    async function fetchItems() {
      var p = phases[ph];
      var r = await fetch(url(p), { credentials: 'same-origin' });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      var d = new DOMParser().parseFromString(await r.text(), 'text/html');
      var g = d.getElementById('product-grid');
      p.page++;
      if (!g || g.tagName !== 'UL') return [];
      return Array.prototype.slice.call(g.querySelectorAll(':scope > li.columns:not(.promotion-column)'));
    }
    // Precio que ve el cliente en la tarjeta (precio de oferta). Shopify ordena por el precio
    // minimo de las variantes (preventa mas barata), asi que se reordena con una ventana.
    function shown(li) {
      if (li.__fvp != null) return li.__fvp;
      var v = Array.prototype.map.call(li.querySelectorAll('.price .amount'), function (a) {
        return parseInt(a.textContent.replace(/[^0-9]/g, ''), 10) || 0;
      }).filter(Boolean);
      return (li.__fvp = v.length ? Math.min.apply(null, v) : 0);
    }
    var pending = [], HOLD = 20;
    function take(all) {
      pending.sort(function (x, y) { return shown(y) - shown(x); });
      return pending.splice(0, all ? pending.length : Math.max(0, pending.length - HOLD));
    }
    async function nextBatch() {
      // Devuelve la proxima tanda (pasa a "sin stock" cuando se acaban los con stock)
      while (ph < phases.length) {
        var items = await fetchItems();
        items.forEach(function (li) {
          var k = key(li);
          if (!k || seen[k]) return;
          seen[k] = 1; pending.push(li);
        });
        if (items.length) {
          var out = take(false);
          if (out.length) return out;
          continue;
        }
        ph++;
        var rest = take(true);
        if (rest.length) return rest;
      }
      finished = true;
      return take(true);
    }
    function append(items) {
      var overlay = grid.querySelector(':scope > li.loading-overlay');
      items.forEach(function (li) { grid.insertBefore(li, overlay); unveil(li); });
    }

    async function first() {
      var promo = grid.querySelector(':scope > li.promotion-column');
      var kids = Array.prototype.slice.call(grid.children);
      var promoIdx = promo ? kids.indexOf(promo) : -1;
      var items = await nextBatch();
      while (items.length < 24 && !finished) items = items.concat(await nextBatch());
      if (!items.length) { reveal(); return; }
      grid.querySelectorAll(':scope > li.columns:not(.promotion-column)').forEach(function (li) { li.remove(); });
      append(items);
      if (promo && promoIdx > -1) {
        promo.remove();
        var ref = grid.children[promoIdx] || grid.querySelector(':scope > li.loading-overlay');
        grid.insertBefore(promo, ref);
      }
      reveal();
      io.observe(sentinel);
      window.addEventListener('scroll', function () {
        if (!busy && !finished && sentinel.getBoundingClientRect().top < window.innerHeight + 600) more();
      }, { passive: true });
    }
    async function more() {
      if (busy || finished) return;
      if (document.getElementById('product-grid') !== grid) { io.disconnect(); return; }
      busy = true; grid.classList.add('fv-loading');
      try {
        var items = await nextBatch();
        while (!items.length && !finished) items = await nextBatch();
        append(items);
      } catch (e) { console.error('[fardo-smart-sort]', e); finished = true; }
      busy = false; grid.classList.remove('fv-loading');
      if (finished) io.disconnect();
      else {
        var rect = sentinel.getBoundingClientRect();
        if (rect.top < window.innerHeight + 600) more();
      }
    }
    var io = new IntersectionObserver(function (es) {
      if (es[0].isIntersecting) more();
    }, { rootMargin: '0px 0px 600px 0px' });

    first().catch(function (e) {
      console.error('[fardo-smart-sort]', e);
      if (pag) { pag.style.display = ''; if (pag.observer) pag.observer.observe(pag); }
      reveal();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
